import { render, staticRenderFns } from "./fvListItem.vue?vue&type=template&id=65c297c2&lang=pug&"
import script from "./fvListItem.vue?vue&type=script&lang=js&"
export * from "./fvListItem.vue?vue&type=script&lang=js&"
import style0 from "./fvListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvListItem.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvListItem.vue
// module id = 118
// module chunks = 0 1